<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { AppTextarea, NativeSelect } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalDisciplineFilesConfirm } from '../../model/modal-discipline-files-confirm.hook'

defineOptions({
  name: 'ModalDisciplineCertificate',
})

const {
  refIsCertificateOpen,
  refIsLoading,
  refCertificateTitle,
  refTaskOptions,
  refComment,
  setTask,
  setComment,
  closeModal,
  generateCertificate,
} = useModalDisciplineFilesConfirm()
</script>

<template>
  <ModalDefault
    :show="refIsCertificateOpen"
    :loading="refIsLoading"
    :title="refCertificateTitle"
    @click:overlay="closeModal"
  >
    <div class="modal-discipline-files">
      <AppText
        name="body1"
        color="slate-700"
        tag="div"
      >
        The certificate was generated automatically.
        <br>
        We can add a comment to the file. To send it, click the button below.
      </AppText>
      <template v-if="refTaskOptions.length">
        <NativeSelect
          id="select-task-tutor"
          name="select_task_tutor"
          label="Task"
          placeholder-enabled
          placeholder="Select task"
          :options="refTaskOptions"
          @change="setTask"
        />
        <AppText
          name="body2"
          color="slate-500"
        >
          Select matching task to upload the file. This task will be automatically completed after generating the
          certificate.
        </AppText>
      </template>
      <AppTextarea
        name="certificate_comment"
        label="Add comment"
        placeholder="Please type here"
        :value="refComment"
        @input="setComment"
      />
    </div>
    <template #controls>
      <div class="modal-discipline-files__controls">
        <BtnPrimary
          text="Submit"
          color="emerald"
          :disabled="refIsLoading"
          @click="generateCertificate"
        />
        <BtnSecondary
          text="Cancel"
          color="black"
          :disabled="refIsLoading"
          @click="closeModal"
        />
      </div>
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineFiles.scss" />
